import uaParser from 'ua-parser-js';

/**
 * parses user agent string with usParser.js to determine if device type is mobile
 * @param userAgent is the user agent string from the header
 * @returns {boolean}
 */

function isMobileDevice(userAgent) {
  return (uaParser(userAgent).device.type === 'mobile');
}

export default isMobileDevice;
